import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=e725d21e&scoped=true"
import script from "./StartPage.vue?vue&type=script&lang=js"
export * from "./StartPage.vue?vue&type=script&lang=js"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=e725d21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e725d21e",
  null
  
)

export default component.exports